import { memo } from "react";
import { Typography } from "antd";
import EllipsisWithTooltip from "./EllipsisWithTooltip";

const { Text } = Typography;

const CustomChip = ({ message, limitMessageLength = false }) => {
  return (
    <div className="chip-wrapper">
      {limitMessageLength ? (
        <EllipsisWithTooltip text={message} maxWidth="200px" />
      ) : (
        <Text
          style={{
            maxWidth: 300,
            whiteSpace: "normal",
            wordBreak: "break-word",
            display: "inline-block",
          }}
        >
          {message}
        </Text>
      )}
    </div>
  );
};

export default memo(CustomChip);
